<app-insights-library__item-selector-shell
  [actions]="itemSelectorActions"
  [selectors]="itemSelectorSelectors"

  [user]="user"
  [busy]="busy"
                   
  (categorySelected)="categorySelected.emit($event)"
  (itemSelected)="itemSelected.emit($event)">

  <ng-template app-insights-library__item-selector__item-actions let-item="item" let-dashboard="item?.dashboard">
    <button trgButton color="primary" class="h-30 lh-30 min-w-100 text-left px-12" 
            [disabled]="busy || !item?.canView" (click)="view(item)">
      <i class="fal fa-desktop i-12 mr-6"></i>
      <span>View</span>
    </button>

    <button trgButton color="primary" class="h-30 lh-30 min-w-100 text-left ml-15 px-12" 
            [disabled]="busy || !item?.canCopy" (click)="copy(item)">
      <i class="fal fa-copy i-12 mr-6"></i>
      <span>Copy to My Dashboards</span>
    </button>

    <button trgButton color="outline" class="h-30 lh-30 min-w-100 text-left ml-15 px-12"
           [ngClass]="{'bgc-grey-5 bc-grey-5 c-white': dashboard?.home}"
           [disabled]="busy || !item?.canAddToHome" (click)="toggleHome(item)">
      <i class="fas fa-home i-14 mr-4 i-circle bgc-grey-14 text-center"
         [ngClass]="{'bgc-white c-grey-5': dashboard?.home}"></i>
      <span>Add to Home</span>
    </button>
  </ng-template>

  <ng-template app-insights-library__item-selector__item-description let-item="item" let-dashboard="item?.dashboard">
    <ng-container *ngIf="item">
      <div class="d-flex justify-content-between">
        <div class="fs-16 c-blue bold text-ellipsis ws-pre-line line-clamp-2 pr-8 align-self-center" [title]="dashboard.name" style="width:305px;">
          {{dashboard.name}}
        </div>
        <div class="align-self-start"style="flex: 0 0 65px">
          <button trgButton color="grey-14" class="trg-toggle min-w-24 size-24 lh-28 br-round mr-8"
                  [class.in]="false"
                  (click)="favourite(item)" click-stop-propagation
                  [disabled]="busy">
            <i *ngIf="!item.favourite" class="far fa-star i-14"></i>
            <i *ngIf="item.favourite" class="fas fa-star i-14"></i>
          </button>

          <button *ngIf="item.canView || item.canCopy || item.canAddToHome"
                  trgButton color="grey-14" class="min-w-24 size-24 lh-28 br-round mr-8" [matMenuTriggerFor]="menu"
                  click-stop-propagation
                  [disabled]="busy">
            <i class="fas fa-ellipsis-v i-12not-2"></i>
          </button>
          <mat-menu #menu="matMenu">
            <button *ngIf="item.canView" mat-menu-item (click)="view(item)" [disabled]="busy">
              <i class="fal fa-desktop mr-6"></i>
              <span>View</span>
            </button>
            <button *ngIf="item.canCopy" mat-menu-item (click)="copy(item)" [disabled]="busy">
              <i class="fal fa-copy mr-6"></i>
              <span>Copy to My Dashboards</span>
            </button>
            <button *ngIf="item.canAddToHome" mat-menu-item (click)="toggleHome(item)" [disabled]="busy">
              <i class="fas fa-home mr-6"></i>
              <span>Add to Home</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <hr />
      <div class="fs-12 c-text-dark-grey">
        <div>
          <h5 class="m-0 bold">Description</h5>
          <p class="m-0 ml-5 mt-5 fs-12">
            {{dashboard.description}}
          </p>
        </div>
        <div class="mt-15">
          <h5 class="m-0 bold">Categories</h5>
          <div class="m-0 ml-5 mt-5 fs-12" [class.two-column-grid]="item.categories.length > 5">
            <span *ngFor="let category of item.categories; last as last">{{category}}<span *ngIf="!last" class="comma">, </span></span>
          </div>
        </div>
        <div class="mt-15" *ngIf="dashboard.visuals?.length">
          <h5 class="m-0 bold">Number of Visuals</h5>
          <p class="m-0 ml-5 mt-5 fs-12">{{dashboard.visuals?.length ?? 0}}</p>
        </div>
        <div class="mt-15" *ngIf="item.fields?.length">
          <h5 class="m-0 bold">Fields</h5>
          <div class="m-0 ml-5 mt-5 fs-12" [class.two-column-grid]="item.fields.length > 5">
            <span *ngFor="let field of item.fields; last as last">{{field}}<span *ngIf="!last" class="comma">, </span></span>
          </div>
        </div>
        <div class="mt-15">
          <h5 class="m-0 bold">Filters</h5>
          <div class="m-0 ml-5 mt-5 fs-12"
               [class.two-column-grid]="item.filters.length > 5">
            <span *ngFor="let filter of item.filters; last as last; index as index">
              <span [innerHTML]="formatFilter(item, index)"></span>
              <span *ngIf="!last" class="comma"><br /> </span>
            </span>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template app-insights-library__item-selector__item-preview let-item="item" let-dashboard="item?.dashboard">
    <div *ngIf="item" class="dashboard-preview">
      <div class="dashboard-preview__grid">
        <app-dashboard-preview
          [dashboard]="dashboard" [displayNames]="true" 
          iconSize="36px"
          smallIconSize="30px"></app-dashboard-preview>
      </div>
    </div>
  </ng-template>

</app-insights-library__item-selector-shell>
